var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "login_info" }, [
      _c("div", { staticClass: "form_item" }, [
        _c("p", [_vm._v(_vm._s(_vm.$t("m.phone")))]),
        _vm._v(" "),
        _c("div", { staticClass: "form_inputbox" }, [
          _c(
            "div",
            {
              staticClass: "seledArea",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.showCountryFun.apply(null, arguments)
                }
              }
            },
            [
              _c("img", {
                staticClass: "flag_icon",
                attrs: { src: _vm.selCountry.logo }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "fc-pad-lr-min" }, [
                _vm._v("+" + _vm._s(_vm.selCountry.countryNum))
              ]),
              _vm._v(" "),
              _c("img", {
                staticClass: "select_icon",
                attrs: {
                  src:
                    _vm.showCountry && _vm.$store.state.isShowSelArea
                      ? require("../../assets/img/icon_up.png")
                      : require("../../assets/img/icon_down.png")
                }
              })
            ]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.mobile,
                expression: "mobile",
                modifiers: { trim: true }
              }
            ],
            staticClass: "login_input",
            attrs: {
              type: "text",
              oninput: "value=value.replace(/\\D/g,'')",
              minlength: "6",
              placeholder: _vm.$t("m.user_enter_bind_phone")
            },
            domProps: { value: _vm.mobile },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.mobile = $event.target.value.trim()
              },
              blur: function($event) {
                return _vm.$forceUpdate()
              }
            }
          }),
          _vm._v(" "),
          _vm.showCountry && _vm.$store.state.isShowSelArea
            ? _c(
                "div",
                { staticClass: "selarea_box" },
                [
                  _c("sel-area", {
                    on: { countryOption: _vm.countryOptionFun }
                  })
                ],
                1
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form_item" }, [
        _c("p", [_vm._v(_vm._s(_vm.$t("m.vericode")))]),
        _vm._v(" "),
        _c("div", { staticClass: "form_inputbox" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.code,
                expression: "code",
                modifiers: { trim: true }
              }
            ],
            staticClass: "login_input smscode_input",
            attrs: {
              type: "text",
              oninput: "value=value.replace(/\\D/g,'')",
              maxlength: "6",
              placeholder: _vm.$t("m.input_vericode")
            },
            domProps: { value: _vm.code },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.code = $event.target.value.trim()
              },
              blur: function($event) {
                return _vm.$forceUpdate()
              }
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "getcode" },
            [
              _c("send-code", {
                attrs: {
                  areaCode: _vm.selCountry.countryNum,
                  mobile: _vm.mobile,
                  scene: 5
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form_item" }, [
        _c("p", [_vm._v(_vm._s(_vm.$t("m.passwd")))]),
        _vm._v(" "),
        _c("div", { staticClass: "form_inputbox" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.passwd,
                expression: "passwd",
                modifiers: { trim: true }
              }
            ],
            staticClass: "login_input smscode_input",
            attrs: {
              type: "password",
              maxlength: "20",
              minlength: "6",
              placeholder: _vm.$t("m.passwd_placeholder")
            },
            domProps: { value: _vm.passwd },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.passwd = $event.target.value.trim()
              },
              blur: function($event) {
                return _vm.$forceUpdate()
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "fc-flex-center" }, [
        _c("div", { staticClass: "login_btn", on: { click: _vm.addPwd } }, [
          _vm._v(_vm._s(_vm.$t("m.Confirm")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "login_btn", on: { click: _vm.cancelPwd } }, [
          _vm._v(_vm._s(_vm.$t("m.cancel")))
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d0ac8fec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0ac8fec","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/forgetPwd.vue
// module id = null
// module chunks = 